var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"componente",style:({width: _vm.width, height:_vm.heigth, position: _vm.position, top:_vm.top, left:_vm.left })},[_c('v-switch',{staticClass:"v-input--reverse",attrs:{"disabled":"","label":`Auto-man`},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }